import { Deserializable } from '../interfaces';

export class Payments implements Deserializable {
  concepto: string | null;
  estatus: string | null;
  fecha: string | null;
  formaPago: string | null;
  id: number | null;
  importe: number | null;
  moneda: string | null;

  constructor() {
    this.concepto = null;
    this.estatus = null;
    this.fecha = null;
    this.formaPago = null;
    this.id = null;
    this.importe = null;
    this.moneda = null;
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
